import React from 'react';
import { Toaster } from 'sonner';
import Header from './Header';
import Footer from './Footer';
import CartSidebar from './CartSidebar';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-[#050505] flex flex-col">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <CartSidebar />
      <Toaster 
        position="bottom-right" 
        toastOptions={{
          style: {
            background: '#111111',
            color: '#EDEDED',
            border: '1px solid rgba(212, 175, 55, 0.3)',
          },
        }}
      />
    </div>
  );
};

export default Layout;
